export default __webpack_public_path__ + "static/media/decayingwall.1631dff3.png";